var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('filial-settings-view',{attrs:{"title":"Отзывы на чеках (QR)","keys":_vm.keys}})}
var staticRenderFns = []

export { render, staticRenderFns }